import { Input } from "antd";
import txtIcon from "../../../images/file-txt-icon.png";
import LabelRequired from "../../Common/LabelRequired";

interface ExtensionBoxDownloadProps {
  fileName: string;
  serialNumber: string;
  hwNumber: string;
  agentName: string;
  agencyEmail: string;
}


const ExtensionBoxDownload = (props: ExtensionBoxDownloadProps) => {
  const {
    fileName,
    serialNumber,
    hwNumber,
    agentName,
    agencyEmail,
  } = props;
  return (
    <div className="p-6 bg-[#F4F6F9] border border-[#BCC2FF] rounded-2xl">
      <div className="flex items-center mb-4">
        <span className="text-[#2C3A4B] text-sm font-medium">{fileName}</span>
        <img className="h-6" src={txtIcon} alt="txtIcon" />
      </div>
      <div className="grid grid-cols-2 gap-x-8 gap-y-6 [&>div]:max-h-[80px] [&>div]:min-h-[80px]">
        {/* <div className="w-1/2 flex flex-col space-y-4"> */}
        <div>
          <LabelRequired text="Camera serial number" />
          <Input
            type="text"
            className="w-full h-[46px]"
            disabled
            value={serialNumber}
          />
        </div>
        <div>
          <LabelRequired text="HW serial number" />
          <Input
            type="text"
            className="w-full h-[46px]"
            disabled
            value={hwNumber}
          />
        </div>
        <div>
          <LabelRequired text="Distributor name" />
          <Input
            type="text"
            className="w-full h-[46px]"
            disabled
            value={agentName}
          />
        </div>
        <div>
          <LabelRequired text="Distributor contact email address" />
          <Input
            type="text"
            className="w-full h-[46px]"
            disabled
            value={agencyEmail}
          />
        </div>
        {/* </div> */}
        {/* <div className="flex flex-col space-y-4 w-1/2"> */}

        {/* </div> */}
      </div>
    </div>
  );
};
export default ExtensionBoxDownload;
